import React, { useState } from "react";
import sgnumbers from "../data/sg_numbers";
import { nanoid } from "nanoid";

export default function OwnerDetails(props) {
  const [sgNumbers, setSgNumbers] = useState(sgnumbers);
  const [ownerDetails, setOwnerDetails] = useState({
    email: "",
    sgnumber: "",
  });
  function submitStateToParent(event) {
    props.handleEmail(event);
  }
  function handleEmailOwn(event) {
    setOwnerDetails((prevState) => ({
      email: ownerDetails.email + event.target.value,
    }));
  }
  return (
    <div className="ownerdetails">
      <label>Email</label>
      <input
        type={"text"}
        onBlur={(event) => submitStateToParent(event)}
        onChange={(event) => handleEmailOwn(event)}
      ></input>
    </div>
  );
}
